import {
  type Space,
  SpaceType,
  SpaceListOrderByEnum,
} from '@tribeplatform/gql-client/types'
import { useSpaces } from '@tribeplatform/react-sdk/hooks'
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../../i18n/index.js'
import { SpreadFilterItems } from '../../components/SpreadFilterItems.js'
import { INFINITE_SPREAD_PAGE_SIZE } from '../../utils/inlineFilters.js'

interface Props {
  value: string[]
  onChange: (tagIds: string[]) => void
}
export const InfiniteSpreadSpacePicker = ({ value, onChange }: Props) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useSpaces({
    variables: {
      limit: INFINITE_SPREAD_PAGE_SIZE,
      orderBy: SpaceListOrderByEnum.CUSTOM_ORDERING_INDEX,
      type: [SpaceType.Group],
    },
  })

  const { nodes: spaces } = simplifyPaginatedResult<Space>(data)

  return (
    <>
      <SpreadFilterItems
        options={spaces.map(({ id }) => id)}
        value={value}
        onChange={onChange}
        isLoading={!data}
      >
        {selectedOption => (
          <span
            title={spaces.find(({ id }) => id === selectedOption)?.name ?? ''}
          >
            {spaces.find(({ id }) => id === selectedOption)?.name ?? ''}
          </span>
        )}
      </SpreadFilterItems>
      {hasNextPage && (
        <Button
          variant="tertiaryNeutral"
          onClick={() => fetchNextPage()}
          className="flex-shrink-0"
          trailingIcon={
            isFetchingNextPage ? (
              <SvgIcon className="animate-spin" size="lg" name="spinner" />
            ) : null
          }
        >
          <T defaultMessage="Show more" id="Generics.ShowMore" />
        </Button>
      )}
    </>
  )
}
